import ReactModal from 'react-modal';

/**
 * This function should be called to notify the component library about the main
 * app element. It is used for accessible modals (main app element is hidden
 * from screen readers when a modal is open).
 */
export var siclSetAppElement = function siclSetAppElement(appElement) {
  ReactModal.setAppElement(appElement);
};